(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prise-rdv"] && !Shopify.designMode) return;
  try {
    
  /* Bascule d'onglets, et rien d'autre.

     Les services sont des liens vers leur fiche : le choix de la date et de
     l'heure a lieu là-bas, sur le vrai calendrier de l'app. Tout ce qui
     simulait des créneaux ici a été retiré. Un motif calculé rendait des
     heures qui n'existaient pas ; le panier aurait reçu un rendez-vous
     imaginaire, ce qui est pire que pas de réservation du tout. */
  (function () {
    document.querySelectorAll('.rdv').forEach(function (racine) {
      var chips = racine.querySelectorAll('.rdv__chip');
      var groupes = racine.querySelectorAll('.rdv__groupe');
      if (chips.length < 2) return;

      function choisir(chip) {
        chips.forEach(function (c) {
          c.setAttribute('aria-selected', String(c === chip));
        });
        groupes.forEach(function (g) {
          g.hidden = g.id !== chip.getAttribute('aria-controls');
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () { choisir(chip); });
        /* Un `role="tablist"` doit répondre aux flèches : sans cela, la
           navigation au clavier saute d'onglet en onglet sans jamais changer
           le panneau affiché. */
        chip.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var liste = Array.prototype.slice.call(chips);
          var i = liste.indexOf(chip);
          var pas = e.key === 'ArrowRight' ? 1 : -1;
          var suivant = liste[(i + pas + liste.length) % liste.length];
          suivant.focus();
          choisir(suivant);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
